import { c as _c } from "react/compiler-runtime";
import { COUNTRIES } from '@onefootprint/core';
import { useQueries } from '@tanstack/react-query';
import { getCoordinatesFromAddress } from './use-address-coordinates';
type Coordinates = {
  lat: number;
  lng: number;
};

/** The center of each country, keyed by ISO 3166 alpha-2 code. A code still loading is left out. */
const useCountryCoordinates = codes => {
  const $ = _c(9);
  let t0;
  if ($[0] !== codes) {
    t0 = codes.map(_temp);
    $[0] = codes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const results = useQueries(t1);
  let t2;
  if ($[4] !== codes || $[5] !== results) {
    let t3;
    if ($[7] !== results) {
      t3 = (code_0, index) => {
        const coordinates_0 = results[index]?.data;
        return coordinates_0 ? [[code_0, coordinates_0]] : [];
      };
      $[7] = results;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = Object.fromEntries(codes.flatMap(t3));
    $[4] = codes;
    $[5] = results;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useCountryCoordinates;
function _temp(code) {
  return {
    queryKey: ["device-insights", "country", code],
    queryFn: async () => {
      const name = COUNTRIES.find(country => country.value === code)?.label ?? code;
      const coordinates = await getCoordinatesFromAddress(name);
      return coordinates?.lat !== undefined && coordinates.lng !== undefined ? {
        lat: coordinates.lat,
        lng: coordinates.lng
      } : null;
    },
    staleTime: Number.POSITIVE_INFINITY
  };
}